import React, {forwardRef} from 'react';

import {BoxedInput, BoxedInputInheritableProps} from './boxedInput';
import {
  BoxedInputElement,
  BoxedInputElementInheritableProps,
  BoxedInputElementTypesEnum,
} from './boxedInputElement';

/*
 * Props.
 */

export type PasswordBoxProps = BoxedInputInheritableProps & BoxedInputElementInheritableProps;

/*
 * Component.
 */

/** Text input with hidden content. */
export const PasswordBox = forwardRef<HTMLDivElement, PasswordBoxProps>((props, ref) => (
  <BoxedInput {...props} boxRef={ref}>
    {(childProps) => (
      <BoxedInputElement {...childProps} {...props} type={BoxedInputElementTypesEnum.PASSWORD} />
    )}
  </BoxedInput>
));
